module.exports = __webpack_public_path__ + "img/UPI-I@3x.0a0c3b81.png";